// @flow

import * as React from 'react';

import clsx from 'clsx';
import { useMatch } from 'react-router-dom';
import { Text, View } from 'reshaped';

import { ProductIcon } from '@gandi/cart';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { mapTags, useTranslator } from '@gandi/translate';

import styles from './DomainIntro.scss';

export type OwnProps = {
  application?: ApplicationSummary,
};

export type Props = {
  ...OwnProps,
};

function DomainIntro({ application }: Props): React.MixedElement {
  const { __ } = useTranslator();

  const studioPage = Boolean(
    useMatch({ path: '/studio/:vhost/convert', end: false }),
  );

  const title = studioPage
    ? __("What's your project's name?")
    : __('Now, choose your free domain');
  const intro = studioPage ? (
    <>
      {__(
        "Every website needs an address on the internet; that's your domain name (think mysite.com).",
      )}
      <br />
      {__("And here's the best part: it's free, today and every year after.")}
    </>
  ) : (
    mapTags(
      __(
        'To run your [[app:Web Hosting]], [[boldText:you need a domain name]], which will be the address of your website.',
      ),
      ({ app, boldText }) => ({
        app: application?.name_label || app,
        boldText: (
          <Text as="b" weight="bold">
            {boldText}
          </Text>
        ),
      }),
    )
  );

  return (
    <>
      <View
        className={clsx(styles.title, studioPage && styles.studio)}
        align="center"
        justify="center"
      >
        <ProductIcon className={styles.icon} type="domain" />
        <View as="h2" textAlign="center">
          {title}
        </View>
      </View>
      <View as="p" direction="row" justify="center" textAlign="center">
        {/* Used to suppress the React key warning => View component */}
        <React.Fragment key="domain-intro">{intro}</React.Fragment>
      </View>

      {!studioPage && (
        <Text align="center" as="p" color="neutral-faded">
          {__('The domain remains free when you renew.')}
          {__(
            'Please note that you won’t be able to choose this free domain later. ',
          )}
        </Text>
      )}
    </>
  );
}

export default DomainIntro;
